module.exports = __webpack_public_path__ + "img/wireless.44c62922.png";